import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import { mapejos } from "../../utils/Mapejos";
import { formatDate, formatNumero } from "../../utils/Utilitats";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { useUserContext } from "../../utils/UserContext";

function nomProveidorEntitat(p) {
  if (!p) return "";
  if (p.TipusEntitat === "Autonom" || p.TipusEntitat === "Particular") {
    const cognoms = [p.Cognom1, p.Cognom2].filter(Boolean).join(" ");
    return cognoms ? `${cognoms}, ${p.Nom}` : (p.Nom || "");
  }
  return p.NomComercial || p.Nom || "";
}

function etiquetaProveidorOpcio(p) {
  const nom = nomProveidorEntitat(p) || `Proveïdor ${p.idProductesProveidors}`;
  const preu = p.PreuNet != null && p.PreuNet !== "" ? `${formatNumero(p.PreuNet)} €` : "—";
  const ref = p.RefProdProv ? ` · ${p.RefProdProv}` : "";
  return `${nom} — ${preu}${ref}`;
}

function etiquetaOfertaOpcio(o) {
  const nom = o.NomProveidor || "Oferta";
  const preu = o.PreuUnitari != null && o.PreuUnitari !== "" ? `${formatNumero(o.PreuUnitari)} €` : "—";
  const ref = o.ReferenciaProv || o.RefProdProv;
  return ref ? `${nom} — ${preu} · ${ref}` : `${nom} — ${preu}`;
}

function formatDataISO(data) {
  if (!data) return "";
  const s = String(data).slice(0, 10);
  const parts = s.split("-");
  if (parts.length !== 3) return s;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

function avuiISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function ofertaCaducada(dataFi) {
  if (!dataFi) return false;
  return String(dataFi).slice(0, 10) < avuiISO();
}

function ofertesDesDeTasca(tasca) {
  if (!tasca) return [];
  if (Array.isArray(tasca.OfertesProducte) && tasca.OfertesProducte.length) {
    return tasca.OfertesProducte;
  }
  if (tasca.ProductesOfertes_idProductesOfertes) {
    return [{
      idProductesOfertes: tasca.ProductesOfertes_idProductesOfertes,
      PreuUnitari: tasca.PreuUnitariOferta,
      Descripcio: tasca.DescripcioOferta,
      ReferenciaProv: tasca.ReferenciaOferta,
      DataFiOferta: tasca.DataFiOferta,
      NomProveidor: tasca.NomProveidorOferta || tasca.DescripcioOferta || "Oferta",
    }];
  }
  return [];
}

function formatPreuPrevist(preu) {
  if (preu === null || preu === undefined || preu === "") return "";
  const n = Number(preu);
  if (!Number.isFinite(n)) return "";
  return `${formatNumero(n)} € / u`;
}

function idOBuit(v) {
  return v != null && v !== "" ? String(v) : "";
}

function idTascaVal(v) {
  if (v == null || v === "" || v === "null") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function recorregutNivell(tasquesList, tasca) {
  if (!Array.isArray(tasquesList) || !tasca) return [];
  const pare = idTascaVal(tasca.idTascaPare);
  return tasquesList
    .filter((t) => idTascaVal(t.idTascaPare) === pare)
    .sort((a, b) => (idTascaVal(a.idTasques) || 0) - (idTascaVal(b.idTasques) || 0));
}

function textFrequencia(freq, freqManual) {
  const dies = Number(freqManual);
  if ((!freq || freq === "") && Number.isFinite(dies) && dies > 0) {
    return `Cada ${dies} dies`;
  }
  return mapejos.freqTasca[freq] || freq || "";
}

function DetallsTasca({ mode, tasca, treball, tasquesList, isSubtasca, nivellText, onSave, onCancel, onNavigate, onObrirCicle }) {
  const { empresaSeleccionada } = useUserContext();
  const isViewMode = mode === "consultar" || mode === "esborrar";

  const [form, setForm] = useState({
    DescripcioTasca: "",
    DetallsTasca: "",
    Quantitat: "",
    Unitats: "ut",
    Durada: "",
    UnitatsTemps: "Hores",
    Prioritat: "Mitjana",
    NumEmpleats: "1",
    Estat: "Pendent",
    TipusTasca: "Normal",
    Freq: "",
    FreqManual: "",
    Horari: "",
    TipusFacturacio: "",
    MotiuNoFacturacio: "",
    DataIniciPrevista: "",
    DataFinalPrevista: "",
    DataInici: "",
    DataFinal: "",
    Materials_idMaterials: "",
    GrupMaObra_idGrupMaObra: "",
    Productes_idProductes: "",
    QuantitatProd: "",
    OrigenProducte: "",
    Productes_Proveidors_idProductesProveidors: "",
    PreuPrevistProducte: "",
    ProductesOfertes_idProductesOfertes: "",
  });

  const [grups, setGrups] = useState([]);
  const [catalog, setCatalog] = useState([]);
  const [fCatProd, setFCatProd] = useState("");
  const [fTipusProd, setFTipusProd] = useState("");
  const [mostrarProducte, setMostrarProducte] = useState(
    () => mode !== "nou" && Boolean(tasca?.Materials_idMaterials || tasca?.Productes_idProductes)
  );
  const [proveidorsProd, setProveidorsProd] = useState([]);
  const [ofertesProd, setOfertesProd] = useState(() => ofertesDesDeTasca(tasca));
  const [avisCicle, setAvisCicle] = useState("");
  const [seccioCicle, setSeccioCicle] = useState(false);
  const [historialCicle, setHistorialCicle] = useState([]);

  useEffect(() => {
    fetchGrups();
    fetchCatalog();
  }, [empresaSeleccionada]);

  useEffect(() => {
    if (tasca && mode !== "nou") {
      setForm({
        DescripcioTasca: tasca.DescripcioTasca || "",
        DetallsTasca: tasca.DetallsTasca || "",
        Quantitat: tasca.Quantitat ?? "",
        Unitats: tasca.Unitats || "ut",
        Durada: tasca.Durada ?? "",
        UnitatsTemps: tasca.UnitatsTemps || "Hores",
        Prioritat: tasca.Prioritat || "Mitjana",
        NumEmpleats: tasca.NumEmpleats ?? "1",
        Estat: tasca.Estat || "Pendent",
        TipusTasca: tasca.TipusTasca || "Normal",
        Freq: (tasca.FreqManual && Number(tasca.FreqManual) > 0) ? "Manual" : (tasca.Freq || ""),
        FreqManual: (tasca.FreqManual && Number(tasca.FreqManual) > 0) ? tasca.FreqManual : "",
        Horari: tasca.Horari || "",
        TipusFacturacio: tasca.TipusFacturacio || "",
        MotiuNoFacturacio: tasca.MotiuNoFacturacio || "",
        DataIniciPrevista: (tasca.DataIniciPrevista || "").toString().slice(0, 10),
        DataFinalPrevista: (tasca.DataFinalPrevista || "").toString().slice(0, 10),
        DataInici: (tasca.DataInici || "").toString().slice(0, 10),
        DataFinal: (tasca.DataFinal || "").toString().slice(0, 10),
        Materials_idMaterials: tasca.Materials_idMaterials != null && tasca.Materials_idMaterials !== ""
          ? String(tasca.Materials_idMaterials)
          : "",
        GrupMaObra_idGrupMaObra: tasca.GrupMaObra_idGrupMaObra != null && tasca.GrupMaObra_idGrupMaObra !== ""
          ? String(tasca.GrupMaObra_idGrupMaObra)
          : "",
        Productes_idProductes: idOBuit(tasca.Productes_idProductes),
        QuantitatProd: tasca.QuantitatProd ?? "",
        OrigenProducte: tasca.OrigenProducte || "",
        Productes_Proveidors_idProductesProveidors: idOBuit(tasca.Productes_Proveidors_idProductesProveidors),
        PreuPrevistProducte: tasca.PreuPrevistProducte ?? "",
        ProductesOfertes_idProductesOfertes: idOBuit(tasca.ProductesOfertes_idProductesOfertes),
      });
      setMostrarProducte(Boolean(tasca.Materials_idMaterials || tasca.Productes_idProductes));
    } else if (mode === "nou") {
      setMostrarProducte(false);
      setProveidorsProd([]);
      setOfertesProd([]);
      setForm((prev) => ({
        ...prev,
        Horari: prev.Horari || treball?.Horari || "",
        DataIniciPrevista: prev.DataIniciPrevista || (treball?.DataIniciPrevista || "").toString().slice(0, 10),
        DataFinalPrevista: prev.DataFinalPrevista || (treball?.DataFinalPrevista || "").toString().slice(0, 10),
      }));
    }
  }, [tasca, mode, treball]);

  const esFilla = mode === "nou" ? Boolean(isSubtasca) : Boolean(tasca?.idTascaPare);
  const pertanyCicle = Boolean(
    mode !== "nou" && tasca && (tasca.TipusTasca === "Ciclica" || tasca.TascaCicleArrel_idTasques)
  );

  useEffect(() => {
    if (form.TipusTasca !== "Ciclica" || esFilla || !treball?.idTreballs || !form.DataIniciPrevista) {
      setAvisCicle("");
      return undefined;
    }
    let cancelat = false;
    const timer = setTimeout(async () => {
      try {
        const resp = await fetch(`${API_URL}/AvisCiclesTasca.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idTreballs: treball.idTreballs,
            idTasques: mode === "nou" ? 0 : (tasca?.idTasques || 0),
            DataIniciPrevista: form.DataIniciPrevista,
            Freq: form.Freq,
            FreqManual: form.FreqManual,
          }),
        });
        const data = await resp.json();
        if (!cancelat) setAvisCicle(data.success ? (data.avis || "") : "");
      } catch (err) {
        if (!cancelat) setAvisCicle("");
      }
    }, 300);
    return () => {
      cancelat = true;
      clearTimeout(timer);
    };
  }, [form.TipusTasca, form.DataIniciPrevista, form.Freq, form.FreqManual, esFilla, treball, mode, tasca]);

  useEffect(() => {
    if (!seccioCicle || !tasca?.idTasques) {
      return undefined;
    }
    let cancelat = false;
    (async () => {
      try {
        const resp = await fetch(`${API_URL}/TasquesCicle.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idTasques: tasca.idTasques }),
        });
        const data = await resp.json();
        if (!cancelat) setHistorialCicle(data.success ? (data.execucions || []) : []);
      } catch (err) {
        if (!cancelat) setHistorialCicle([]);
      }
    })();
    return () => { cancelat = true; };
  }, [seccioCicle, tasca]);

  const fetchGrups = async () => {
    if (!empresaSeleccionada?.IdEmpresa) return;
    try {
      const resp = await fetch(`${API_URL}/Grupsmaobra.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idEmpresa: empresaSeleccionada.IdEmpresa }),
      });
      const data = await resp.json();
      if (data.success) setGrups(data.grups || []);
    } catch (err) {
      console.error("Error carregant grups:", err);
    }
  };

  const fetchCatalog = async () => {
    if (!empresaSeleccionada?.IdEmpresa) return;
    try {
      const resp = await fetch(`${API_URL}/Productes.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idEmpresa: empresaSeleccionada.IdEmpresa }),
      });
      const data = await resp.json();
      if (data.success) setCatalog(data.productes || []);
    } catch (err) {
      console.error("Error carregant productes:", err);
    }
  };

  useEffect(() => {
    const idProd = form.Productes_idProductes;
    if (!idProd || !empresaSeleccionada?.IdEmpresa) {
      setProveidorsProd([]);
      return;
    }
    let cancelat = false;
    (async () => {
      try {
        const resp = await fetch(`${API_URL}/Proveidorsproducte.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idProductes: idProd,
            idEmpresa: empresaSeleccionada.IdEmpresa,
            nomesActius: 1,
          }),
        });
        const data = await resp.json();
        if (!cancelat) setProveidorsProd(data.success ? (data.proveidors || []) : []);
      } catch (err) {
        console.error("Error carregant proveïdors del producte:", err);
        if (!cancelat) setProveidorsProd([]);
      }
    })();
    return () => { cancelat = true; };
  }, [form.Productes_idProductes, empresaSeleccionada]);

  useEffect(() => {
    const idProd = form.Productes_idProductes || tasca?.Productes_idProductes;
    const idTreball = treball?.idTreballs || tasca?.Treballs_idTreballs;
    const mateixProducte = String(tasca?.Productes_idProductes || "") === String(idProd || "");
    const fallback = mateixProducte ? ofertesDesDeTasca(tasca) : [];
    setOfertesProd(fallback);
    if (!idProd || !idTreball) {
      return;
    }
    let cancelat = false;
    (async () => {
      try {
        const resp = await fetch(`${API_URL}/Ofertesproductetreball.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idTreballs: idTreball, idProductes: idProd }),
        });
        const data = await resp.json();
        if (cancelat) return;
        const llista = data.success ? (data.ofertes || []) : [];
        setOfertesProd(llista.length ? llista : fallback);
      } catch (err) {
        console.error("Error carregant ofertes del producte:", err);
        if (!cancelat) setOfertesProd(fallback);
      }
    })();
    return () => { cancelat = true; };
  }, [form.Productes_idProductes, tasca, treball?.idTreballs]);

  useEffect(() => {
    if (mode === "nou" || !tasca) {
      if (mode === "nou") {
        setFCatProd("");
        setFTipusProd("");
      }
      return;
    }
    if (!catalog.length) return;
    const prod = tasca.Productes_idProductes
      ? catalog.find((p) => String(p.idProductes) === String(tasca.Productes_idProductes))
      : null;
    const mat = !prod && tasca.Materials_idMaterials
      ? catalog.find((p) => String(p.idMaterials) === String(tasca.Materials_idMaterials))
      : null;
    const src = prod || mat;
    setFCatProd(src?.Categoria || "");
    setFTipusProd(src?.Tipus || "");
  }, [tasca, mode, catalog]);

  const onCanviCategoriaProd = (cat) => {
    setFCatProd(cat);
    setFTipusProd("");
    setForm((prev) => ({
      ...prev,
      Materials_idMaterials: "",
      Productes_idProductes: "",
      Productes_Proveidors_idProductesProveidors: "",
      ProductesOfertes_idProductesOfertes: "",
      PreuPrevistProducte: "",
    }));
  };

  const onCanviTipusProd = (tip) => {
    setFTipusProd(tip);
    setForm((prev) => ({
      ...prev,
      Materials_idMaterials: "",
      Productes_idProductes: "",
      Productes_Proveidors_idProductesProveidors: "",
      ProductesOfertes_idProductesOfertes: "",
      PreuPrevistProducte: "",
    }));
  };

  const onCanviMaterial = (idMat) => {
    const mat = catalog.find((p) => String(p.idMaterials) === String(idMat));
    if (mat) {
      setFCatProd(mat.Categoria || "");
      setFTipusProd(mat.Tipus || "");
    }
    setForm((prev) => {
      const prodOk = idMat && catalog.some(
        (p) => String(p.idProductes) === String(prev.Productes_idProductes) && String(p.idMaterials) === String(idMat)
      );
      return {
        ...prev,
        Materials_idMaterials: idMat || "",
        Productes_idProductes: prodOk ? prev.Productes_idProductes : "",
        Productes_Proveidors_idProductesProveidors: prodOk ? prev.Productes_Proveidors_idProductesProveidors : "",
        ProductesOfertes_idProductesOfertes: prodOk ? prev.ProductesOfertes_idProductesOfertes : "",
        OrigenProducte: prodOk ? prev.OrigenProducte : (idMat ? "PENDENT" : ""),
        PreuPrevistProducte: prodOk ? prev.PreuPrevistProducte : "",
      };
    });
  };

  const onCanviProducte = (idProd) => {
    const prod = catalog.find((p) => String(p.idProductes) === String(idProd));
    if (prod) {
      setFCatProd(prod.Categoria || "");
      setFTipusProd(prod.Tipus || "");
    }
    setForm((prev) => {
      const mateix = String(prev.Productes_idProductes || "") === String(idProd || "");
      return {
        ...prev,
        Productes_idProductes: idProd || "",
        Materials_idMaterials: prod ? String(prod.idMaterials) : prev.Materials_idMaterials,
        QuantitatProd: idProd && (!prev.QuantitatProd || Number(prev.QuantitatProd) === 0)
          ? "1"
          : (idProd ? prev.QuantitatProd : ""),
        Productes_Proveidors_idProductesProveidors: mateix ? prev.Productes_Proveidors_idProductesProveidors : "",
        ProductesOfertes_idProductesOfertes: mateix ? prev.ProductesOfertes_idProductesOfertes : "",
        PreuPrevistProducte: mateix ? prev.PreuPrevistProducte : "",
        OrigenProducte: idProd
          ? (prev.Productes_idProductes && (prev.OrigenProducte === "ESTOC" || prev.OrigenProducte === "PENDENT")
            ? prev.OrigenProducte
            : "PROVEIDOR")
          : (prev.Materials_idMaterials ? "PENDENT" : ""),
      };
    });
  };

  const onCanviOrigen = (origen) => {
    setForm((prev) => ({
      ...prev,
      OrigenProducte: origen,
      Productes_Proveidors_idProductesProveidors: origen === "PROVEIDOR" ? prev.Productes_Proveidors_idProductesProveidors : "",
      PreuPrevistProducte: "",
    }));
  };

  const onCanviProveidor = (idPp) => {
    setForm((prev) => ({
      ...prev,
      Productes_Proveidors_idProductesProveidors: idPp || "",
      OrigenProducte: idPp ? "PROVEIDOR" : prev.OrigenProducte,
      ProductesOfertes_idProductesOfertes: "",
      PreuPrevistProducte: "",
    }));
  };

  const onCanviOferta = (idOferta) => {
    setForm((prev) => ({
      ...prev,
      ProductesOfertes_idProductesOfertes: idOferta || "",
    }));
  };

  const treureProducte = () => {
    setFCatProd("");
    setFTipusProd("");
    setProveidorsProd([]);
    setOfertesProd([]);
    setMostrarProducte(false);
    setForm((prev) => ({
      ...prev,
      Materials_idMaterials: "",
      Productes_idProductes: "",
      QuantitatProd: "",
      OrigenProducte: "",
      Productes_Proveidors_idProductesProveidors: "",
      ProductesOfertes_idProductesOfertes: "",
      PreuPrevistProducte: "",
    }));
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCanviFrequencia = (valor) => {
    setForm((prev) => (
      valor === "Manual"
        ? { ...prev, Freq: "Manual", FreqManual: prev.FreqManual || "" }
        : { ...prev, Freq: valor, FreqManual: "" }
    ));
  };

  const avuiLocalISO = () => avuiISO();

  const handleCanviEstat = (nouEstat) => {
    setForm((prev) => {
      const next = { ...prev, Estat: nouEstat };
      if (nouEstat === "En curs") {
        next.DataInici = prev.DataInici || avuiLocalISO();
        if (prev.Estat === "Acabat") next.DataFinal = "";
      } else if (nouEstat === "Acabat") {
        next.DataFinal = prev.DataFinal || avuiLocalISO();
        next.DataInici = prev.DataInici || (treball?.DiaInici || "").toString().slice(0, 10);
      } else if (prev.Estat === "Acabat") {
        next.DataFinal = "";
      }
      return next;
    });
  };

  const handleCanviInici = (valor) => {
    setForm((prev) => {
      if (prev.DataInici) {
        return valor ? { ...prev, DataInici: valor } : prev;
      }
      return { ...prev, DataIniciPrevista: valor };
    });
  };

  const handleCanviFinal = (valor) => {
    setForm((prev) => {
      if (prev.DataFinal) {
        return valor ? { ...prev, DataFinal: valor } : prev;
      }
      return { ...prev, DataFinalPrevista: valor };
    });
  };

  const handleSubmit = async () => {
    if (mode === "esborrar") {
      const confirmar = window.confirm(
        "Estàs segur que vols esborrar aquesta tasca? S'esborraran també les subtasques i les dependències associades."
      );
      if (!confirmar) return;

      try {
        const resp = await fetch(`${API_URL}/Esborrartasca.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idTasques: tasca.idTasques }),
        });
        const data = await resp.json();
        if (data.success) {
          if (onSave) onSave();
        } else {
          alert(data.message || "Error esborrant la tasca.");
        }
      } catch (err) {
        alert("Error de connexió esborrant la tasca.");
      }
      return;
    }

    const endpoint = mode === "nou" ? "Novatasca.php" : "Modificartasca.php";
    const payload = { ...form };
    delete payload.PreuPrevistProducte;

    const origen = payload.OrigenProducte || "";
    const idPp = payload.Productes_Proveidors_idProductesProveidors || "";
    if (origen === "ESTOC" || origen === "PENDENT") {
      payload.OrigenProducte = origen;
      payload.Productes_Proveidors_idProductesProveidors = "";
    } else if (origen === "PROVEIDOR" && idPp) {
      payload.OrigenProducte = "PROVEIDOR";
      payload.Productes_Proveidors_idProductesProveidors = idPp;
    } else {
      delete payload.OrigenProducte;
      delete payload.Productes_Proveidors_idProductesProveidors;
    }
    payload.ProductesOfertes_idProductesOfertes = payload.ProductesOfertes_idProductesOfertes || "";

    const inici = payload.DataInici || payload.DataIniciPrevista;
    const final = payload.DataFinal || payload.DataFinalPrevista;
    const diaTreball = (treball?.DiaInici || "").toString().slice(0, 10);
    if (payload.DataInici && diaTreball && payload.DataInici < diaTreball) {
      alert("La data d'inici de la tasca no pot ser anterior a la data d'inici del treball.");
      return;
    }
    if (payload.DataInici && payload.DataFinal && payload.DataFinal < payload.DataInici) {
      alert("La data final no pot ser anterior a la data d'inici.");
      return;
    }
    if (!payload.DataInici && !payload.DataFinal
        && payload.DataIniciPrevista && payload.DataFinalPrevista
        && payload.DataFinalPrevista < payload.DataIniciPrevista) {
      alert("La data final prevista no pot ser anterior a la data d'inici prevista.");
      return;
    }
    if (inici && final && final < inici) {
      alert("La data final no pot ser anterior a la data d'inici.");
      return;
    }
    if (payload.Freq === "Manual") {
      payload.Freq = "";
    }
    if (esFilla) {
      payload.TipusTasca = "Normal";
      payload.Freq = "";
      payload.FreqManual = "";
    }
    if (payload.TipusTasca === "Ciclica") {
      if (esFilla) {
        alert("Una subtasca no pot ser cíclica.");
        return;
      }
      if (!payload.DataIniciPrevista) {
        alert("Una tasca cíclica ha de tenir data d'inici prevista.");
        return;
      }
      const dies = Number(payload.FreqManual);
      if (!payload.Freq && !(dies > 0)) {
        alert("Cal una freqüència o un nombre de dies més gran que 0.");
        return;
      }
    }

    if (mode === "nou") {
      payload.Treballs_idTreballs = treball.idTreballs;
      if (tasca?.idTasques) {
        payload.idTascaPare = tasca.idTasques;
      }
    } else {
      payload.idTasques = tasca.idTasques;
    }

    try {
      const resp = await fetch(`${API_URL}/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (data.success) {
        if (onSave) onSave();
      } else {
        alert(data.message || "Error guardant la tasca.");
      }
    } catch (err) {
      alert("Error de connexió guardant la tasca.");
    }
  };

  const recorregut = recorregutNivell(tasquesList, tasca);
  const idxNav = tasca
    ? recorregut.findIndex((t) => idTascaVal(t.idTasques) === idTascaVal(tasca.idTasques))
    : -1;

  const handleNavigate = (direction) => {
    if (!onNavigate || idxNav < 0 || recorregut.length <= 1) return;
    const n = recorregut.length;
    onNavigate(recorregut[(idxNav + direction + n) % n]);
  };

  TeclaEscEnter(onCancel, null);

  const camp = (label, content, mida = "mig") => {
    const extra =
      mida === "ample"
        ? "dv2-field--ample"
        : mida === "llarg"
        ? "dv2-field--llarg"
        : mida === "curt"
        ? "dv2-field--curt"
        : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className="dv2-label">{label}</span>
        {content}
      </label>
    );
  };

  const valor = (txt) => <span className="dv2-value">{txt || "—"}</span>;
  const potNavegar = mode === "consultar" && idxNav >= 0 && recorregut.length > 1;

  const card = (num, title, children) => (
    <section className="dv2-card">
      <div className="dv2-card-head">
        <span className="dv2-card-num">{num}</span>
        <h2 className="dv2-card-title">{title}</h2>
      </div>
      <div className="dv2-fields dv2-fields--sizes">{children}</div>
    </section>
  );

  const veDePressupost = mode !== "nou" && Boolean(tasca?.PartidesPressupost_idPartidesPressupost);
  const infoPressupost = veDePressupost ? (
    <span
      className="dv2-btn dv2-btn--icon dv2-btn--ghost"
      title="Aquesta tasca ve d'una partida de pressupost. Canviar el producte no modifica el que es va vendre."
      aria-label="Origen de pressupost"
    >
      i
    </span>
  ) : null;
  const cardProducteHead = (num, title, avisaOferta) => (
    <div className="dv2-card-head">
      <span className="dv2-card-num">{num}</span>
      <h2 className="dv2-card-title">{title}</h2>
      {avisaOferta ? <span className="dv2-chip dv2-chip--ok">Hi ha oferta</span> : null}
      {infoPressupost}
    </div>
  );
  const catsProd = [...new Set(catalog.map((p) => p.Categoria).filter(Boolean))].sort((a, b) => a.localeCompare(b, "ca"));
  const tipusProd = [...new Set(
    catalog.filter((p) => !fCatProd || p.Categoria === fCatProd).map((p) => p.Tipus).filter(Boolean)
  )].sort((a, b) => a.localeCompare(b, "ca"));
  const materialsProd = [...new Map(
    catalog
      .filter((p) => !fCatProd || p.Categoria === fCatProd)
      .filter((p) => !fTipusProd || p.Tipus === fTipusProd)
      .map((p) => [String(p.idMaterials), p])
  ).values()].sort((a, b) =>
    (a.NomGeneric || a.DescripcioMaterial || "").localeCompare(b.NomGeneric || b.DescripcioMaterial || "", "ca")
  );
  const productesProd = catalog
    .filter((p) => !fCatProd || p.Categoria === fCatProd)
    .filter((p) => !fTipusProd || p.Tipus === fTipusProd)
    .filter((p) => !form.Materials_idMaterials || String(p.idMaterials) === String(form.Materials_idMaterials))
    .sort((a, b) => `${a.Marca || ""} ${a.Model || ""}`.localeCompare(`${b.Marca || ""} ${b.Model || ""}`, "ca"));
  const etiquetaProducte = (p) => {
    const nom = `${p.Marca || ""} ${p.Model || ""}`.trim();
    return nom || p.Descripcio || `Producte ${p.idProductes}`;
  };
  const teMaterial = Boolean(isViewMode ? tasca?.Materials_idMaterials : form.Materials_idMaterials);
  const teProducte = Boolean(isViewMode ? tasca?.Productes_idProductes : form.Productes_idProductes);
  const marcaModelDe = (marca, model) => `${marca || ""} ${model || ""}`.trim();
  const producteForm = catalog.find((p) => String(p.idProductes) === String(form.Productes_idProductes));
  const marcaModelTriat = form.Productes_idProductes
    ? (
      producteForm
        ? marcaModelDe(producteForm.Marca, producteForm.Model)
        : (String(tasca?.Productes_idProductes || "") === String(form.Productes_idProductes)
          ? marcaModelDe(tasca?.MarcaProducte, tasca?.ModelProducte)
          : "")
    )
    : "";
  const marcaModelSuggerit = !form.Productes_idProductes && !isViewMode
    ? marcaModelDe(tasca?.MarcaProducteSuggerit, tasca?.ModelProducteSuggerit)
    : "";
  const marcaModelConsulta = marcaModelDe(tasca?.MarcaProducte, tasca?.ModelProducte);
  const marcaModelSuggeritConsulta = marcaModelDe(tasca?.MarcaProducteSuggerit, tasca?.ModelProducteSuggerit);
  const preuConsulta = formatPreuPrevist(tasca?.PreuPrevistProducte);
  const origenConsulta = mapejos.origenProducte[tasca?.OrigenProducte] || tasca?.OrigenProducte;
  const teOfertaDisponible = ofertesProd.length > 0 || Number(tasca?.NumOfertesProducte) > 0;
  const idOfertaAplicada = tasca?.ProductesOfertes_idProductesOfertes;
  const ofertaAplicada = Boolean(idOfertaAplicada);
  const ofertaSelConsulta = ofertesProd.find(
    (o) => String(o.idProductesOfertes) === String(idOfertaAplicada)
  );
  const textOfertaConsulta = ofertaAplicada
    ? (ofertaSelConsulta
      ? etiquetaOfertaOpcio(ofertaSelConsulta)
      : [
          tasca.NomProveidorOferta || tasca.DescripcioOferta,
          tasca.PreuUnitariOferta != null && tasca.PreuUnitariOferta !== ""
            ? `${formatNumero(tasca.PreuUnitariOferta)} €`
            : null,
          tasca.ReferenciaOferta,
        ].filter(Boolean).join(" — ") || "Oferta aplicada")
    : (teOfertaDisponible ? "Hi ha oferta disponible. Es pot aplicar en modificar." : "");
  const dataFiOfertaAplicada = ofertaSelConsulta?.DataFiOferta || tasca?.DataFiOferta;
  const avisOfertaCaducada = ofertaAplicada && ofertaCaducada(dataFiOfertaAplicada)
    ? `Oferta caducada${dataFiOfertaAplicada ? ` el ${formatDataISO(dataFiOfertaAplicada)}` : ""}.`
    : "";
  const avisOfertaPressupost = (
    veDePressupost
    && tasca?.PreuPrioritariMaterialPartida === "Oferta"
    && !ofertaAplicada
    && ofertaCaducada(tasca?.DataFiOfertaPartida)
    && tasca?.PreuUnitariOfertaPartida != null
    && tasca?.PreuUnitariOfertaPartida !== ""
  )
    ? `El pressupost utilitzava una oferta de ${formatNumero(tasca.PreuUnitariOfertaPartida)} € caducada el ${formatDataISO(tasca.DataFiOfertaPartida)}.`
    : "";
  const ofertesSelect = [...ofertesProd];
  if (
    form.ProductesOfertes_idProductesOfertes
    && !ofertesSelect.some((o) => String(o.idProductesOfertes) === String(form.ProductesOfertes_idProductesOfertes))
  ) {
    ofertesSelect.unshift({
      idProductesOfertes: form.ProductesOfertes_idProductesOfertes,
      NomProveidor: tasca?.NomProveidorOferta || tasca?.DescripcioOferta || "Oferta",
      PreuUnitari: tasca?.PreuUnitariOferta,
      ReferenciaProv: tasca?.ReferenciaOferta,
      DataFiOferta: tasca?.DataFiOferta,
    });
  }
  const ofertaSelForm = ofertesSelect.find(
    (o) => String(o.idProductesOfertes) === String(form.ProductesOfertes_idProductesOfertes)
  );
  const avisOfertaCaducadaForm = form.ProductesOfertes_idProductesOfertes && ofertaCaducada(ofertaSelForm?.DataFiOferta || tasca?.DataFiOferta)
    ? `Oferta caducada${(ofertaSelForm?.DataFiOferta || tasca?.DataFiOferta) ? ` el ${formatDataISO(ofertaSelForm?.DataFiOferta || tasca?.DataFiOferta)}` : ""}.`
    : "";
  const proveidorsSelect = [...proveidorsProd];
  if (
    form.Productes_Proveidors_idProductesProveidors
    && !proveidorsSelect.some((p) => String(p.idProductesProveidors) === String(form.Productes_Proveidors_idProductesProveidors))
  ) {
    proveidorsSelect.unshift({
      idProductesProveidors: form.Productes_Proveidors_idProductesProveidors,
      Nom: tasca?.NomProveidorProducte || `Proveïdor ${form.Productes_Proveidors_idProductesProveidors}`,
      PreuNet: null,
      RefProdProv: tasca?.RefProveidorProducte || "",
    });
  }

  const camps = isViewMode && tasca ? (
    <>
      {nivellText ? <p className="dv2-hint">{nivellText}</p> : null}
      {card(1, "Quantitat i descripció", (
        <>
          {camp("Quantitat", valor(tasca.Quantitat != null && tasca.Quantitat !== "" ? String(tasca.Quantitat) : ""), "curt")}
          {camp("Unitats", valor(mapejos.unitatsMesura[tasca.Unitats] || tasca.Unitats), "curt")}
          {camp("Descripció", valor(tasca.DescripcioTasca), "llarg")}
          {camp("Qtat. real", valor(tasca.QuantitatReal != null && tasca.QuantitatReal !== "" ? String(tasca.QuantitatReal) : ""), "curt")}
        </>
      ))}
      {(teMaterial || teProducte || preuConsulta || teOfertaDisponible) ? (
        <section className="dv2-card">
          {cardProducteHead(2, "Producte", teOfertaDisponible)}
          <div className="dv2-fields dv2-fields--sizes">
            {tasca.NomMaterial ? camp("Material", valor(tasca.NomMaterial), "llarg") : null}
            {teProducte
              ? camp("Marca / Model", valor(marcaModelConsulta || tasca.DescripcioProducte), "llarg")
              : marcaModelSuggeritConsulta
              ? camp("Marca / Model", valor(`${marcaModelSuggeritConsulta} (suggerit)`), "llarg")
              : teMaterial
              ? camp("Producte", valor("No concretat"), "llarg")
              : null}
            {teProducte && tasca.QuantitatProd != null && tasca.QuantitatProd !== ""
              ? camp("Qtat. producte", valor(String(tasca.QuantitatProd)), "curt")
              : null}
            {teMaterial || teProducte ? camp("Origen", valor(origenConsulta)) : null}
            {tasca.OrigenProducte === "PROVEIDOR"
              ? camp("Proveïdor", valor(tasca.NomProveidorProducte), "llarg")
              : null}
            {textOfertaConsulta ? camp("Oferta", valor(textOfertaConsulta), "llarg") : null}
            {avisOfertaCaducada ? <p className="dv2-hint">{avisOfertaCaducada}</p> : null}
            {avisOfertaPressupost ? <p className="dv2-hint">{avisOfertaPressupost}</p> : null}
            {preuConsulta
              ? camp(
                  ofertaAplicada ? "Preu previst (oferta)" : "Preu previst",
                  valor(preuConsulta),
                  "curt"
                )
              : null}
            {tasca.OrigenProducte === "ESTOC" ? (
              <p className="dv2-hint">Previsió d'estoc. Encara no descompta les existències.</p>
            ) : null}
          </div>
        </section>
      ) : null}
      {card(3, "Temps", (
        <>
          {camp("Durada", valor(tasca.Durada ? `${tasca.Durada} ${mapejos.unitatsTemps[tasca.UnitatsTemps] || tasca.UnitatsTemps || ""}` : ""), "mig")}
          {camp("Nº empleats", valor(tasca.NumEmpleats != null ? String(tasca.NumEmpleats) : ""), "curt")}
          {camp("Grup MO", valor(tasca.NomGrupMaObra), "llarg")}
          {tasca.NomAgrupacio ? camp("Agrupació", valor(tasca.NomAgrupacio), "llarg") : null}
        </>
      ))}
      {card(4, "Estat", (
        <>
          {camp("Estat", valor(mapejos.estatTasca[tasca.Estat] || tasca.Estat))}
          {camp("Prioritat", valor(mapejos.prioritatTasca[tasca.Prioritat] || tasca.Prioritat))}
          {camp("Tipus", valor(mapejos.tipusTasca[tasca.TipusTasca] || tasca.TipusTasca))}
          {tasca.TipusTasca === "Ciclica" && camp("Freqüència", valor(textFrequencia(tasca.Freq, tasca.FreqManual)))}
          {tasca.Horari ? camp("Horari", valor(tasca.Horari), "ample") : null}
          {camp("Facturació", valor(mapejos.tipusFacturacio[tasca.TipusFacturacio] || tasca.TipusFacturacio), "llarg")}
          {tasca.MotiuNoFacturacio ? camp("Motiu", valor(tasca.MotiuNoFacturacio), "ample") : null}
        </>
      ))}
      {card(5, "Dates", (
        <>
          {camp(
            tasca.DataInici ? "Inici" : "Inici (previst)",
            valor(
              (formatDate(tasca.DataInici || tasca.DataIniciPrevista) || "") +
                (tasca.DataInici && tasca.DataIniciPrevista && String(tasca.DataInici).slice(0, 10) !== String(tasca.DataIniciPrevista).slice(0, 10)
                  ? ` (previst: ${formatDate(tasca.DataIniciPrevista)})`
                  : "")
            )
          )}
          {camp(
            tasca.DataFinal ? "Final" : "Final (previst)",
            valor(
              (formatDate(tasca.DataFinal || tasca.DataFinalPrevista) || "") +
                (tasca.DataFinal && tasca.DataFinalPrevista && String(tasca.DataFinal).slice(0, 10) !== String(tasca.DataFinalPrevista).slice(0, 10)
                  ? ` (previst: ${formatDate(tasca.DataFinalPrevista)})`
                  : "")
            )
          )}
          {camp("Data alta", valor(formatDate(tasca.DataAlta)))}
        </>
      ))}
      {tasca.DetallsTasca
        ? card(6, "Detalls", camp("Detalls", valor(tasca.DetallsTasca), "ample"))
        : null}
    </>
  ) : (
    <>
      {mode === "nou" && nivellText ? <p className="dv2-hint">{nivellText}</p> : null}
      {card(1, "Quantitat i descripció", (
        <>
          {camp(
            "Quantitat",
            <input className="dv2-input" type="number" step="0.01" value={form.Quantitat} onChange={(e) => handleChange("Quantitat", e.target.value)} />,
            "curt"
          )}
          {camp(
            "Unitats",
            <select className="dv2-select" value={form.Unitats} onChange={(e) => handleChange("Unitats", e.target.value)}>
              {Object.entries(mapejos.unitatsMesura).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>,
            "curt"
          )}
          {camp(
            "Descripció",
            <textarea className="dv2-textarea" value={form.DescripcioTasca} onChange={(e) => handleChange("DescripcioTasca", e.target.value)} />,
            "llarg"
          )}
        </>
      ))}
      {!mostrarProducte ? (
        <section className="dv2-card">
          {cardProducteHead(2, "Producte", false)}
          <div className="dv2-fields dv2-fields--sizes">
            {formatPreuPrevist(form.PreuPrevistProducte)
              ? camp("Preu previst", valor(formatPreuPrevist(form.PreuPrevistProducte)), "curt")
              : null}
            <div className="dv2-controlRow">
              <button
                type="button"
                className="dv2-btn dv2-btn--ghost"
                onClick={() => setMostrarProducte(true)}
              >
                + Afegir material/producte
              </button>
            </div>
          </div>
        </section>
      ) : (
        <section className="dv2-card">
          {cardProducteHead(2, "Producte", ofertesProd.length > 0 || Number(tasca?.NumOfertesProducte) > 0)}
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Categoria",
              <select className="dv2-select" value={fCatProd} onChange={(e) => onCanviCategoriaProd(e.target.value)}>
                <option value="">Totes</option>
                {catsProd.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            )}
            {camp(
              "Tipus",
              <select className="dv2-select" value={fTipusProd} onChange={(e) => onCanviTipusProd(e.target.value)}>
                <option value="">Tots</option>
                {tipusProd.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            )}
            {camp(
              "Material",
              <select className="dv2-select" value={form.Materials_idMaterials} onChange={(e) => onCanviMaterial(e.target.value)}>
                <option value="">— Sense material —</option>
                {materialsProd.map((m) => (
                  <option key={m.idMaterials} value={String(m.idMaterials)}>
                    {m.NomGeneric || m.DescripcioMaterial || `Material ${m.idMaterials}`}
                  </option>
                ))}
              </select>,
              "llarg"
            )}
            {camp(
              "Producte",
              <select className="dv2-select" value={form.Productes_idProductes} onChange={(e) => onCanviProducte(e.target.value)}>
                <option value="">{form.Materials_idMaterials ? "No concretat" : "— Sense producte —"}</option>
                {productesProd.map((p) => (
                  <option key={p.idProductes} value={String(p.idProductes)}>
                    {etiquetaProducte(p)}
                  </option>
                ))}
              </select>,
              "llarg"
            )}
            {marcaModelTriat
              ? camp("Marca / Model", valor(marcaModelTriat), "llarg")
              : marcaModelSuggerit
              ? camp("Marca / Model", valor(`${marcaModelSuggerit} (suggerit)`), "llarg")
              : null}
            {(form.Materials_idMaterials || form.Productes_idProductes) ? camp(
              "Qtat. producte",
              <input
                className="dv2-input"
                type="number"
                step="0.01"
                value={form.QuantitatProd}
                onChange={(e) => handleChange("QuantitatProd", e.target.value)}
              />,
              "curt"
            ) : null}
            {form.Productes_idProductes ? camp(
              "Origen",
              <>
                <select className="dv2-select" value={form.OrigenProducte} onChange={(e) => onCanviOrigen(e.target.value)}>
                  {Object.entries(mapejos.origenProducte).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
                {form.OrigenProducte === "ESTOC" ? (
                  <span className="dv2-hint">Previsió d'estoc. Encara no descompta les existències.</span>
                ) : null}
              </>
            ) : (form.Materials_idMaterials ? camp("Origen", valor(mapejos.origenProducte.PENDENT)) : null)}
            {form.Productes_idProductes && form.OrigenProducte === "PROVEIDOR" ? camp(
              "Proveïdor",
              <select
                className="dv2-select"
                value={form.Productes_Proveidors_idProductesProveidors}
                onChange={(e) => onCanviProveidor(e.target.value)}
              >
                <option value="">— El més econòmic en desar —</option>
                {proveidorsSelect.map((p) => (
                  <option key={p.idProductesProveidors} value={String(p.idProductesProveidors)}>
                    {etiquetaProveidorOpcio(p)}
                  </option>
                ))}
              </select>,
              "llarg"
            ) : null}
            {form.Productes_idProductes && (ofertesSelect.length > 0 || Number(tasca?.NumOfertesProducte) > 0) ? camp(
              "Oferta",
              <select
                className="dv2-select"
                value={form.ProductesOfertes_idProductesOfertes}
                onChange={(e) => onCanviOferta(e.target.value)}
              >
                <option value="">— Sense oferta (preu actual) —</option>
                {ofertesSelect.map((o) => (
                  <option key={o.idProductesOfertes} value={String(o.idProductesOfertes)}>
                    {etiquetaOfertaOpcio(o)}
                  </option>
                ))}
              </select>,
              "llarg"
            ) : null}
            {avisOfertaCaducadaForm ? <p className="dv2-hint">{avisOfertaCaducadaForm}</p> : null}
            {avisOfertaPressupost ? <p className="dv2-hint">{avisOfertaPressupost}</p> : null}
            {formatPreuPrevist(form.PreuPrevistProducte)
              ? camp(
                  tasca?.ProductesOfertes_idProductesOfertes ? "Preu previst (oferta)" : "Preu previst",
                  valor(formatPreuPrevist(form.PreuPrevistProducte)),
                  "curt"
                )
              : null}
            <div className="dv2-controlRow">
              <button type="button" className="dv2-btn dv2-btn--ghost" onClick={treureProducte}>
                Treure producte
              </button>
            </div>
          </div>
        </section>
      )}
      {card(3, "Temps", (
        <>
          {camp(
            "Durada",
            <input className="dv2-input" type="number" step="0.01" value={form.Durada} onChange={(e) => handleChange("Durada", e.target.value)} />,
            "curt"
          )}
          {camp(
            "Unitats temps",
            <select className="dv2-select" value={form.UnitatsTemps} onChange={(e) => handleChange("UnitatsTemps", e.target.value)}>
              {Object.entries(mapejos.unitatsTemps).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          )}
          {camp(
            "Grup mà d'obra",
            <select className="dv2-select" value={form.GrupMaObra_idGrupMaObra} onChange={(e) => handleChange("GrupMaObra_idGrupMaObra", e.target.value)}>
              <option value="">— Sense grup —</option>
              {grups.map((g) => <option key={g.idGrupMaObra} value={String(g.idGrupMaObra)}>{g.Nom}</option>)}
            </select>,
            "llarg"
          )}
          {camp(
            "Nº empleats",
            <input className="dv2-input" type="number" value={form.NumEmpleats} onChange={(e) => handleChange("NumEmpleats", e.target.value)} />,
            "curt"
          )}
          {camp(
            "Horari",
            <input className="dv2-input" type="text" maxLength={255} value={form.Horari} onChange={(e) => handleChange("Horari", e.target.value)} />,
            "ample"
          )}
        </>
      ))}
      {card(4, "Estat", (
        <>
          {camp(
            "Prioritat",
            <select className="dv2-select" value={form.Prioritat} onChange={(e) => handleChange("Prioritat", e.target.value)}>
              {Object.entries(mapejos.prioritatTasca).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          )}
          {camp(
            "Estat",
            <select className="dv2-select" value={form.Estat} onChange={(e) => handleCanviEstat(e.target.value)}>
              {Object.entries(mapejos.estatTasca).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          )}
          {!esFilla ? camp(
            "Tipus tasca",
            <select className="dv2-select" value={form.TipusTasca} onChange={(e) => handleChange("TipusTasca", e.target.value)}>
              {Object.entries(mapejos.tipusTasca).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          ) : camp("Tipus tasca", valor("Normal"))}
          {form.TipusTasca === "Ciclica" && !esFilla && camp(
            "Freqüència",
            <select className="dv2-select" value={form.Freq} onChange={(e) => handleCanviFrequencia(e.target.value)}>
              <option value="">— Seleccionar —</option>
              {Object.entries(mapejos.freqTasca).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              <option value="Manual">Manual</option>
            </select>
          )}
          {form.TipusTasca === "Ciclica" && !esFilla && form.Freq === "Manual" && camp(
            "Dies",
            <input className="dv2-input" type="number" min="1" value={form.FreqManual} onChange={(e) => handleChange("FreqManual", e.target.value)} />,
            "curt"
          )}
          {avisCicle ? <p className="dv2-hint">{avisCicle}</p> : null}
          {camp(
            "Facturació",
            <select className="dv2-select" value={form.TipusFacturacio} onChange={(e) => handleChange("TipusFacturacio", e.target.value)}>
              <option value="">— Seleccionar —</option>
              {Object.entries(mapejos.tipusFacturacio).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>,
            "llarg"
          )}
          {form.TipusFacturacio === "No_facturable" && camp(
            "Motiu no facturació",
            <input className="dv2-input" type="text" value={form.MotiuNoFacturacio} onChange={(e) => handleChange("MotiuNoFacturacio", e.target.value)} />,
            "ample"
          )}
        </>
      ))}
      {card(5, "Dates", (
        <>
          {form.TipusTasca === "Ciclica" && !esFilla ? camp(
            "Inici previst",
            <input className="dv2-input" type="date" value={form.DataIniciPrevista || ""} onChange={(e) => handleChange("DataIniciPrevista", e.target.value)} />
          ) : null}
          {(form.TipusTasca !== "Ciclica" || esFilla || form.DataInici) && camp(
            form.DataInici ? "Inici" : "Inici (previst)",
            <>
              <input className="dv2-input" type="date" value={form.DataInici || form.DataIniciPrevista || ""} onChange={(e) => handleCanviInici(e.target.value)} />
              {form.DataInici && form.DataIniciPrevista ? (
                <span className="dv2-hint">Previst: {formatDate(form.DataIniciPrevista)}</span>
              ) : null}
            </>
          )}
          {camp(
            form.DataFinal ? "Final" : "Final (previst)",
            <>
              <input className="dv2-input" type="date" value={form.DataFinal || form.DataFinalPrevista || ""} onChange={(e) => handleCanviFinal(e.target.value)} />
              {form.DataFinal && form.DataFinalPrevista ? (
                <span className="dv2-hint">Previst: {formatDate(form.DataFinalPrevista)}</span>
              ) : null}
            </>
          )}
        </>
      ))}
      {card(6, "Detalls", (
        <>
          {camp(
            "Detalls",
            <textarea className="dv2-textarea" value={form.DetallsTasca} onChange={(e) => handleChange("DetallsTasca", e.target.value)} />,
            "ample"
          )}
        </>
      ))}
    </>
  );

  const historial = (
    <div className="dv2-tableWrap">
      <table className="dv2-table">
        <thead>
          <tr>
            <th>Prevista</th>
            <th>Realitzada</th>
            <th>Estat</th>
            <th>Freqüència</th>
          </tr>
        </thead>
        <tbody>
          {historialCicle.map((ex) => (
            <tr
              key={ex.idTasques}
              onClick={() => onObrirCicle && Number(ex.idTasques) !== Number(tasca?.idTasques) && onObrirCicle(ex.idTasques)}
              style={{ cursor: onObrirCicle ? "pointer" : "default" }}
            >
              <td>{ex.DataIniciPrevista ? formatDate(ex.DataIniciPrevista) : "—"}</td>
              <td>{ex.DataFinal ? formatDate(ex.DataFinal) : "—"}</td>
              <td>{mapejos.estatTasca[ex.Estat] || ex.Estat}</td>
              <td>{textFrequencia(ex.Freq, ex.FreqManual) || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {historialCicle.length === 0 ? <p className="dv2-empty">Encara no hi ha execucions d'aquest cicle.</p> : null}
    </div>
  );

  return (
    <>
      {pertanyCicle && (
        <nav className="dv2-subnav" aria-label="Seccions de la tasca">
          <button type="button" className={`dv2-subnav-btn ${!seccioCicle ? "is-active" : ""}`} onClick={() => setSeccioCicle(false)}>
            Dades
          </button>
          <button type="button" className={`dv2-subnav-btn ${seccioCicle ? "is-active" : ""}`} onClick={() => setSeccioCicle(true)}>
            Tasques cícliques
          </button>
        </nav>
      )}
      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          S'esborraran també les subtasques i les dependències associades.
        </div>
      )}
      <div className="dv2-entity-body">{seccioCicle && pertanyCicle ? historial : camps}</div>
      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={() => handleNavigate(-1)} title="Anterior">‹</button>
              <span className="dv2-recordNav-info">{idxNav + 1} / {recorregut.length}</span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={() => handleNavigate(1)} title="Següent">›</button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>Cancel·lar</button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>Esborrar tasca</button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar tasca" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default DetallsTasca;
